// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-banner[data-v-7ad3f6c8]{position:relative}[data-v-7ad3f6c8] .lazy-background{position:absolute;top:0;right:0;left:0;bottom:0}.mobile-background[data-v-7ad3f6c8]{display:block}@media(min-width:768px){.mobile-background[data-v-7ad3f6c8]{display:none}}.desktop-background[data-v-7ad3f6c8]{display:none}@media(min-width:768px){.desktop-background[data-v-7ad3f6c8]{display:block}}.slot-content[data-v-7ad3f6c8]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
